@if ((searchShopBy$ | async) !== 'autocomplete') {
  <div id="search-selection" class="pad-bottom-5">
    <ul class="column twelve in-line flex justify-space-between">
      <li
        data-cy="drpSearchByLocationForm"
        class="inline-block column twelve lg-six"
        [ngClass]="{ selected: (searchShopBy$ | async) === 'location' }"
        (click)="changeSearchBy('location')"
      >
        <div class="step" title="Search by Location">
          <a>Search by Location</a>
        </div>
      </li>
      <li
        data-cy="drpSearchByNameForm"
        class="inline-block column twelve lg-six"
        [ngClass]="{ selected: (searchShopBy$ | async) === 'name' }"
        (click)="changeSearchBy('name')"
      >
        <div class="step text-right" title="Search by Name">
          <a>Search by Name</a>
        </div>
      </li>
    </ul>
  </div>
}

@if ((searchShopBy$ | async) !== 'autocomplete') {
  <div>
    @if ((searchShopBy$ | async) === 'location') {
      <drp-search-by-location-form
        [predictions]="predictions$ | async"
        [addressToPopulate]="addressToPopulate$ | async"
        [appState]="appState$ | async"
        [mapTriggerState]="mapTriggerState$ | async"
        [inputSearchValue]="inputSearchValue$ | async"
        (searchedAddress)="setSearchedValue($event)"
        (requestAutocompleteEvent)="onRequestAutocompleteEvent($event, 'geocode')"
        (userSelectedAddress)="getAddressToPopulateForm($event)"
      >
      </drp-search-by-location-form>
    }
    @if ((searchShopBy$ | async) === 'name') {
      <drp-search-by-name-form (searchedName)="setSearchedValue($event)"> </drp-search-by-name-form>
    }
  </div>
}

@if ((searchShopBy$ | async) === 'autocomplete') {
  <div id="basic-search">
    <drp-search-by-autocomplete-form
      [isPredicting]="predicting$ | async"
      [predictions]="predictions$ | async"
      [selectedPredictionAddress]="addressToPopulate$ | async"
      (searchedValueChange)="setSearchedValue($event)"
      (requestAutocompleteEvent)="onRequestAutocompleteEvent($event, 'establishment')"
      (predictionSelected)="getAddressToPopulateForm($event)"
    >
    </drp-search-by-autocomplete-form>
  </div>
}
